<template>
  <div>
    <div
      v-if="
        profileRequirements.length > 0 ||
          qualificationRequirements.length > 0 ||
          experienceRequirements.length > 0
      "
    >
      <RequirementGroup
        v-for="group in profileRequirements"
        :key="`profile-requirement-${group.id}`"
        :group="group"
        :first="group === profileRequirements[0]"
        :last="group === profileRequirements[profileRequirements.length - 1]"
      />
      <RequirementGroup
        v-for="group in qualificationRequirements"
        :key="`qualification-requirement-${group.id}`"
        :group="group"
        :first="group === qualificationRequirements[0]"
        :last="group === qualificationRequirements[qualificationRequirements.length - 1]"
      />
      <RequirementGroup
        v-for="group in experienceRequirements"
        :key="`experience-requirement-${group.id}`"
        :group="group"
        :first="group === experienceRequirements[0]"
        :last="group === experienceRequirements[experienceRequirements.length - 1]"
      />
    </div>
    <div v-else>
      No specific requirements have been set and this opportunity is open to anyone to apply.
    </div>
    <div
      class="mt-2"
      :class="themes.candidate.light.mutedText"
      v-if="askSupport && opportunity.organization"
    >
      Meet the screening requirements but unable to apply? Contact our support team for assistance
      <a @click="openCrisp" class="font-weight-bold" :class="themes.candidate.light.link">
        here.
      </a>
    </div>
  </div>
</template>

<script>
// Components
import RequirementGroup from '@/components/guest/opportunities/RequirementGroup'

// Helpers
import _ from 'lodash'

export default {
  props: {
    opportunity: { type: Object, required: true },
    requirementGroups: { type: Array, required: true },
    askSupport: { type: Boolean, default: false },
  },

  components: { RequirementGroup },

  computed: {
    profile() {
      return this.$store.getters['candidate/profile/model']
    },

    profileRequirements() {
      if (this.requirementGroups) {
        return this.requirementGroups.filter(group => group.type === 'ProfileRequirementGroup')
      }
    },

    qualificationRequirements() {
      if (this.requirementGroups) {
        return this.requirementGroups.filter(
          group => group.type === 'ProfileQualificationRequirementGroup'
        )
      }
    },

    experienceRequirements() {
      if (this.requirementGroups) {
        return this.requirementGroups.filter(group => group.type === 'ExperienceRequirementGroup')
      }
    },

    crispEligibilityData() {
      const groups = JSON.parse(JSON.stringify(this.requirementGroups.filter(g => g && !g.satisfied)))
      const requirements = _.flatten(groups.map(g => g.requirements))

      return requirements.filter(r => r && !r.satisfied).map((r, i) => {
        // Use the reason if available since it has the most information
        if (r.reason) {
          return `${i + 1}. ${r.reason}`
        } else {
          switch(r.type) {
            case 'Requirement::QualificationInstitution':
              return `${i + 1}. ${r.descriptor} ${r.institution.name}`
            default:
              return `${i + 1}. ${r.descriptor} ${r.value}`
          }
        }
      }).join('\n')
    },
  },

  methods: {
    openCrisp() {
      if (!window.CRISP_READY || !this.profile) return

      window.$crisp.push(['do', 'chat:open'])
      window.$crisp.push([
        "do", "message:send",
        [
          "text",
          `Hi, I think I should qualify for
          ${this.opportunity.organization.name}'s ${this.opportunity.name}
          but I don't. Could you perhaps help me understand why I'm not eligible to apply?
          \n\n ==== For support ==== \n${this.crispEligibilityData}
          \n\n/eligibilities?profile=${this.profile.id}&opportunity=${this.opportunity.id}
          `,
        ],
      ])
    },
  },
}
</script>
